// The one conversion vocabulary the whole site shares: open a card on the
// board (/talk) or put a time straight on the calendar (/book). Authored
// natively per locale for the ICP reader.

const ctaContent = {
  'en-US': {
    nav: { book: 'Book a conversation' },
    close: {
      kicker: 'Next step',
      title: 'Start the conversation.',
      body: 'Open a card on our board and get an answer within one business day, or pick a time straight on the calendar.',
      talk: 'Open a card',
      book: 'Book a conversation',
    },
  },
  'pt-BR': {
    nav: { book: 'Agendar conversa' },
    close: {
      kicker: 'Próximo passo',
      title: 'Comece a conversa.',
      body: 'Abra um cartão no nosso quadro e receba resposta em até um dia útil, ou escolha um horário direto na agenda.',
      talk: 'Abrir um cartão',
      book: 'Agendar uma conversa',
    },
  },
  es: {
    nav: { book: 'Agendar conversación' },
    close: {
      kicker: 'Siguiente paso',
      title: 'Empieza la conversación.',
      body: 'Abre una tarjeta en nuestro tablero y recibe respuesta en un día hábil, o elige un horario directo en el calendario.',
      talk: 'Abrir una tarjeta',
      book: 'Agendar una conversación',
    },
  },
}

export const getCtaContent = (language) => {
  if (!language) return ctaContent['en-US']
  if (language.startsWith('pt')) return ctaContent['pt-BR']
  if (language.startsWith('es')) return ctaContent.es
  return ctaContent['en-US']
}

export default ctaContent
